import { render, staticRenderFns } from "./u-tit-wrap-subtitle.vue?vue&type=template&id=2ebd3154&scoped=true&"
import script from "./u-tit-wrap-subtitle.vue?vue&type=script&lang=js&"
export * from "./u-tit-wrap-subtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebd3154",
  null
  
)

export default component.exports